module.exports = __webpack_public_path__ + "static/media/fast-money-icon.ffce1776.svg";